module.exports = __webpack_public_path__ + "img/selected2-min.c3506216.png";